import { render } from "./WarningInfo.vue?vue&type=template&id=e587a510&scoped=true"
import script from "./WarningInfo.vue?vue&type=script&lang=js"
export * from "./WarningInfo.vue?vue&type=script&lang=js"

import "./WarningInfo.vue?vue&type=style&index=0&id=e587a510&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e587a510"]])

export default __exports__